<div class="exception-body">
  <div class="exception-topbar">
    <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','','_self');" class="logo">
      <img [src]="this.logo_url" alt="eglobaldoctors" />
    </a>
  </div>
  <div class="container top-bottom-space">
    <div class="ui-lg-6">
      <div class="exception-panel" style="padding-top: 10%;">
        <h1 class="exception-summary">Session Expired</h1>
        <div>
          <button type="button" pButton label="Go To Home" [routerLink]="['/', this.slug]"></button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-home-footer></app-home-footer>